<template>
    <div>
        <SectionHeader slot="header">
            <h1>Complete Registration</h1>
        </SectionHeader>
        <SectionWrapper class="whiteframe shadowframe">
            <p>Please fill in your e-mail address to complete your registration.</p>
            <form v-on:submit.prevent="onSubmit">
                <FieldWrapper>
                    <input
                        tabindex="2"
                        type="email"
                        v-model="user.email"
                        name="email"
                        placeholder="E-mail"
                        v-validate.initial="validatorDefinitions.email_new"
                        data-vv-scope="register"
                        data-vv-delay="500"
                        autocomplete="email"
                    />
                    <div slot="errors" v-if="errors.has('email', 'register')">
                        {{ errors.first("email", "register") }}
                    </div>
                </FieldWrapper>
                <FieldWrapper>
                    <input
                        tabindex="3"
                        type="email"
                        v-model="user.email_confirmation"
                        name="email_confirmation"
                        placeholder="E-mail Confirmation"
                        v-validate="validatorDefinitions.email_confirmation"
                        data-vv-scope="register"
                        autocomplete="off"
                    />
                    <div slot="errors" v-if="errors.has('email_confirmation', 'register')">
                        {{ errors.first("email_confirmation", "register") }}
                    </div>
                </FieldWrapper>

                <DecoratedButton tabindex="7" type="submit" :loading="loading"> COMPLETE REGISTRATION </DecoratedButton>
            </form>
        </SectionWrapper>
    </div>
</template>

<script>
import Legal from "@bistudio/bohemia-vue-components-old/src/components/footer/partials/Legal";

export default {
    name: "auth-register-complete-form",
    components: { Legal },
    data: function () {
        return {
            loading: false,
        };
    },
    computed: {
        user() {
            return {
                email: "",
                email_confirmation: "",
            };
        },
    },
    methods: {
        onSubmit() {
            this.$validator.validateAll("register").then((valid) => {
                if (valid) {
                    this.loading = true;
                    this.services.UserResource.update(this.user)
                        .then(() => {
                            this.services.AuthService.redirect();
                        })
                        .catch((e) => {
                            this.loading = false;
                        });
                }
            });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
